// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oX1AwlHRv9ckd1VN{display:grid;grid-column-gap:4px;grid-template-columns:20px 1fr;justify-content:center;min-height:16px;align-items:center;height:32px}.oX1AwlHRv9ckd1VN .khfPrqrZpCE4RaUv{width:20px;height:20px}.oX1AwlHRv9ckd1VN .b96wjGvSdnsQjLxi{line-height:20px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.RaX8mnAyHwrWkjzn{min-height:16px;margin-top:7px}.vuqjTKtuJHgJboXU{display:flex;align-items:center;justify-content:center;column-gap:8px;margin-right:8px;padding-top:4px}.RaX8mnAyHwrWkjzn{height:100%;min-height:25px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userBox": `oX1AwlHRv9ckd1VN`,
	"userAvatar": `khfPrqrZpCE4RaUv`,
	"userName": `b96wjGvSdnsQjLxi`,
	"unassigned": `RaX8mnAyHwrWkjzn`,
	"onlyOverdueSwitch": `vuqjTKtuJHgJboXU`
};
export default ___CSS_LOADER_EXPORT___;
